import { css, useTheme } from "@emotion/react";
import { useContext } from "react";

import cardComponentContext from "./cardComponentContext";
import parseStyle from "./parseStyle";
import Stack from "./Stack.jsx";
import useThemeProps from "./useThemeProps.jsx";

export default function CardMeta(props) {
  const theme = useTheme();
  props = useThemeProps({ props, name: "CardMeta" });
  let { children, color, style, ...restProps } = props;
  const { color: backgroundColor } = useContext(cardComponentContext);
  color ??= [backgroundColor, "text", "-500"];
  return (
    <Stack
      direction="row"
      justifyContent="start"
      divider={{ style: { borderWidth: "2px" } }}
      css={css`
        color: ${theme.getColor(color)};
        font-size: 0.875rem;
        font-weight: 600;
        line-height: 125%;
        letter-spacing: -0.01px;
        ${parseStyle(style, theme)}
      `}
      {...restProps}
    >
      {children}
    </Stack>
  );
}
